import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import s from './s.module.less';
import BookingLink from './components/BookingLink';
import UpdateUniprofile from './components/UpdateUniprofile';
import Previwe from './components/Preview';
import useGetBookingLinks from 'hooks/helloklarityOps/useGetBookingLinks';
import { generateUUID, getUrlParam } from 'utils/common';
import { Button, Select, Spin, Tabs, message } from 'antd';
import { EBookingListAction, IEditBookingLink } from './type';
import useFetchAuditDetailData from '../ListToChannelDetailPage/hooks/useFetchAuditDetailData';
import {
    EProviderListMappingStatusValue,
    EProviderMappingStatusValue,
    IHelloKlarityBookingLink,
    IHelloKlarityViewPostMessageData,
    IProfileDataSaveInput,
    ISaveGenericInfoReqInput,
    ISaveSpecificInfoReqListInput,
} from 'types/operation';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import {
    helloklarityMappingGolive,
    updateHelloKlarityListingStatus,
    saveSpecialtyHighlight,
    getAppointmentsByBookingLinks,
    batchUpdateBookinglinks,
    pauseHelloKlarityListing,
} from 'api/operation';
import { getProviderNameDisplay, hasEffectiveMic } from 'utils/provider';
import { Provider } from 'types/provider';
import GlobalLayerStore from 'store/GlobalLayer';
import {
    getDraftData,
    removeDraftStorage,
    setDraftData,
} from 'utils/helloklarity';
import {
    EType,
    IDraftStorage,
    IGetSpecificConditionDetailResponse,
} from 'types/helloKlarity';
import MappingModalConfirm from 'components/PorivderMappingModals/MappingModalConfirm';
import useLoadBasicData from 'hooks/useLoadBasicData';
import useGetSpecialtyNServiceType from 'hooks/helloklarityOps/useGetSpecialtyNServiceType';
import useDeleteOldPPPPreviewDraftData from 'hooks/useDeleteOldPPPPreviewDraftData';
import UpdateSpecificUniprofile from './components/UpdateSpecificUniprofile';
import { EditModuleEnum } from 'types/practiceFront';
import useGetSpecificConditionListByProviderId from 'hooks/helloklarityOps/useGetSpecificConditionListByProviderId';
import useGetSpecificConditionDetail from 'hooks/helloklarityOps/useGetSpecificConditionDetail';

const CustomizeHelloKlarityPPP = () => {
    const [, setGlobalLayer] = GlobalLayerStore.useStore();
    const navigate = useNavigate();
    const id = Number(getUrlParam('id'));
    const mappingStatus = getUrlParam('mappingStatus');
    const listStatus = getUrlParam('profileStatus');
    const conflict = getUrlParam('conflict');
    const providerId = Number(getUrlParam('providerId'));
    const slug = decodeURIComponent(getUrlParam('slug') || '');
    const [statusChangeLoading, setStatusChangeLoading] = useState(false);
    const [hightlights, setHighlights] = useState<string[]>([]);
    const [tabKey, setTabKey] = useState('genericProfile');
    const [conditionId, setConditionId] = useState<string | undefined>(undefined);
    const [bookingLinkListManualEdited, setBookingLinkListManualEdited] =
    useState({});

    const [pendingSubmitPrograms, setPendingSubmitPrograms] = useState<
    {
        programId: number;
        activeStatus: 'A' | 'D';
        displayStatus: 'A' | 'D';
        isDeleted: boolean;
    }[]
    >([]);

    const {
        data: providerData,
        refetch,
        loading: fetchLoading,
    } = useFetchAuditDetailData({
        channelId: -1,
        providerId,
    });

    useDeleteOldPPPPreviewDraftData(providerId);
    const [data, bookingListLoading, , bookingListrefetch] =
    useGetBookingLinks(providerId);

    const [
        specificConditionDetail,
        specificConditionDetailLoading,,
        fetchSpecificConditionDetail,
    ] = useGetSpecificConditionDetail(providerId, conditionId, false);

    const [specificDetails, setSpecificDetails] = useState<
    ISaveSpecificInfoReqListInput[]
    >([]);
    const [genericDetails, setGenericDetails] =
    useState<ISaveGenericInfoReqInput>();

    const [bookingListData, setBookingListData] = useState<IEditBookingLink[]>(
        [],
    );

    const [specialtiesIsEdting, setSpecialtiesIsEdting] = useState(false);
    const [edtingModules, setEditingModules] = useState({
        bookingLink: false,
        specialties: false,
    });
    const iframeEl = useRef<HTMLIFrameElement | null>(null);
    const pppTabIndexOffset = useRef(0);

    const { profile } = providerData;

    const providerName = getProviderNameDisplay(profile as Partial<Provider>);
    const [iframeLoaded, setIframeLoaded] = useState<
    { [key: string]: boolean } | undefined
    >();
    const [errorMsg, setErrorMsg] = useState('');

    const postMessageData = useRef<IHelloKlarityViewPostMessageData>({
        tabKey: '',
        hightlights: [],
        appointmentList: [],
        hasStorage: false,
        genericDraftData: undefined,
        specificDraftData: undefined,
    });

    const [loadBaiscData] = useLoadBasicData();

    const [specialtyNServiceTypeData] = useGetSpecialtyNServiceType(providerId);

    useEffect(() => {
        loadBaiscData();
    }, [loadBaiscData]);

    const checkHasStoragePostMessage = useCallback(() => {
        const draftData: IDraftStorage = getDraftData(providerId);
        const hasStorage = !!draftData;
        postMessageData.current.hasStorage = hasStorage;

        return hasStorage;
    }, [providerId]);

    const handlePostMessage = useCallback(() => {
        if (iframeEl.current && iframeEl.current.contentWindow) {
            const {
                hightlights: hightlightsData,
                appointmentList,
                genericDraftData,
                specificDraftData,
                tabKey: tabKeyData,
            } = postMessageData.current;

            setTimeout(() => {
                iframeEl.current?.contentWindow?.postMessage(
                    {
                        sk: 'sk',
                        tabKey: tabKeyData,
                        hightlights: hightlightsData.join(','),
                        appointmentList,
                        hasStorage: checkHasStoragePostMessage(),
                        genericDraftData,
                        specificDraftData,
                    },
                    '*',
                );
            }, 300);
        }
    }, [checkHasStoragePostMessage]);

    const handleGetAppointmentsByBookingLinks = useCallback(
        async (listData: IEditBookingLink[]) => {
            const pramas = listData
                .filter((e) => !e.isEditing && e.status !== EBookingListAction.DELETE)
                .map((e) => e.directBookingLink);
            if (pramas.length > 0) {
                try {
                    const res = await getAppointmentsByBookingLinks(pramas);

                    if (res && !res.error) {
                        const appointmentList = res.data?.data;
                        postMessageData.current.appointmentList = appointmentList;

                        handlePostMessage();
                    } else {
                        message.error(res?.error);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
        [handlePostMessage],
    );

    const handleGetData = useCallback(() => {
        const draftData: IDraftStorage = getDraftData(providerId);
        const {
            bookingListData: bookingList,
            specialtiesHighlights,
            profileData,
        } = draftData || {};

        if (bookingList && bookingList.length > 0) {
            const draftBookingLinks = bookingList.map(
                (e: IHelloKlarityBookingLink) => {
                    return {
                        ...e,
                        isEditing: false,
                        uuid: e.uuid || generateUUID(),
                        conditions:
              typeof e.conditions === 'string'
                  ? e.conditions.split(',')
                  : e.conditions || [],
                    };
                },
            );
            setBookingListData(draftBookingLinks);
            handleGetAppointmentsByBookingLinks(draftBookingLinks);
        } else if (data && data.length > 0) {
            const listData = data.map((e: IHelloKlarityBookingLink) => {
                return {
                    ...e,
                    isEditing: false,
                    uuid: e.uuid || generateUUID(),
                    conditions:
            typeof e.conditions === 'string'
                ? e.conditions.split(',').filter((e) => !!e)
                : e.conditions || [],
                };
            });

            setBookingListData(listData);
        }

        if (specialtiesHighlights) {
            const draftSpecialtiesHighlights = specialtiesHighlights.split(',');

            postMessageData.current.hightlights = draftSpecialtiesHighlights;
        } else {
            postMessageData.current.hightlights =
        providerData?.practice.specialtyHighlightList || [];
        }

        if (profileData && profileData.genericInfoReq) {
            const preGenericInfoReq = profileData.genericInfoReq;
            if (
                profileData.genericInfoReq.tags &&
        profileData.genericInfoReq.tags.length > 0
            ) {
                preGenericInfoReq.tags = profileData.genericInfoReq.tags;
            } else {
                preGenericInfoReq.tags = providerData?.tags?.filter((e) => !!e) || [];
            }

            if (
                profileData.genericInfoReq.prescribableMedications &&
        profileData.genericInfoReq.prescribableMedications.length > 0
            ) {
                preGenericInfoReq.prescribableMedications =
          profileData.genericInfoReq.prescribableMedications;
            } else {
                preGenericInfoReq.prescribableMedications =
          providerData?.prescribableMedications?.filter((e) => !!e) || [];
            }

            if (
                profileData.genericInfoReq.nonPrescribableMedications &&
        profileData.genericInfoReq.nonPrescribableMedications.length > 0
            ) {
                preGenericInfoReq.nonPrescribableMedications =
          profileData.genericInfoReq.nonPrescribableMedications;
            } else {
                preGenericInfoReq.nonPrescribableMedications =
          providerData?.nonPrescribableMedications?.filter((e) => !!e) || [];
            }

            setGenericDetails(preGenericInfoReq);
            postMessageData.current.genericDraftData = preGenericInfoReq;
        } else {
            const detailData = {
                tags: providerData?.tags || [],
                prescribableMedications: providerData?.prescribableMedications || [],
                nonPrescribableMedications:
          providerData?.nonPrescribableMedications || [],
            };
            setGenericDetails(detailData);
            postMessageData.current.genericDraftData = detailData;
        }

        const specificInfoByCurrentSelectedConditionInDraftData =
      profileData?.specificInfoReqList?.find(
          (e) => e.condition === conditionId,
      );

        if (
            profileData &&
      profileData.specificInfoReqList &&
      profileData.specificInfoReqList.length > 0 &&
      specificInfoByCurrentSelectedConditionInDraftData
        ) {
            const condition =
        conditionId || profileData.specificInfoReqList[0]?.condition;
            setSpecificDetails(profileData.specificInfoReqList);
            setConditionId(condition);
            postMessageData.current.specificDraftData =
        profileData.specificInfoReqList.find((e) => e.condition === condition);
        } else if (specificConditionDetail) {
            const detailData = {
                condition: specificConditionDetail?.conditionName,
                headLines: specificConditionDetail?.headLines,
                aboutMe: specificConditionDetail?.aboutMe,
                tags: specificConditionDetail?.tags?.filter((e) => !!e) || [],
                prescribableMedications:
          specificConditionDetail?.prescribableMedications?.filter(
              (e) => !!e,
          ) || [],
                nonPrescribableMedications:
          specificConditionDetail?.nonPrescribableMedications?.filter(
              (e) => !!e,
          ) || [],
                specialty: specificConditionDetail?.specialty,
                specialtyHighlight: specificConditionDetail?.specialtyHighlight,
                conditionTreated: specificConditionDetail?.conditionTreated,
            };

            setSpecificDetails([detailData]);
            postMessageData.current.specificDraftData = detailData;
        }

        handlePostMessage();
    }, [
        conditionId,
        data,
        providerData,
        handleGetAppointmentsByBookingLinks,
        handlePostMessage,
        providerId,
        specificConditionDetail,
    ]);

    useEffect(() => {
    // 因为booking link的请求异步，iframe 的html加载完毕也是异步。
    // 所以避免因为2者异步导致数据没有同步，所以以iframe为主，等html加载完，再进行booking link的解析
        if (typeof iframeLoaded !== 'undefined') {
            handleGetData();
        }
    }, [handleGetData, iframeLoaded]);

    useEffect(() => {
        const bookingLinkIsEditing = bookingListData.find((e) => !!e.isEditing);
        setEditingModules({
            bookingLink: !!bookingLinkIsEditing,
            specialties: !!specialtiesIsEdting,
        });
    }, [bookingListData, specialtiesIsEdting]);

    // useEffect(() => {
    //     const draftData: IDraftStorage = {
    //         [providerId]: {
    //             bookingLink: bookingListData.filter((e) => e.directBookingLink),
    //             specialtiesHighlights: hightlights.join(','),
    //         },
    //     };

    //     setDraftData(draftData);
    // }, [bookingListData, hightlights, providerId]);

    const handleTabChange = useCallback(
        (key: string) => {
            if (iframeEl.current && iframeEl.current.contentWindow) {
                // const { hightlights: hightlightsData, appointmentList, genericDraftData, specificDraftData } = postMessageData.current;

                postMessageData.current.tabKey = key;
                handlePostMessage();
            }
        },
        [checkHasStoragePostMessage],
    );

    const setSavingDataToLocalstorage = useCallback(
        (key: string, v: any) => {
            let draftData = getDraftData(providerId);
            const defaultData = {
                bookingListData: [],
                specialtiesHighlights: '',
                profileData: {
                    genericInfoReq: {
                        specialtiesHighlights: '',
                        tags: [],
                        prescribableMedications: [],
                        nonPrescribableMedications: [],
                    },
                    specificInfoReqList: [],
                },
            };
            if (!draftData) {
                draftData = defaultData;
            }

            draftData[key] = v;

            setDraftData(draftData, providerId);
        },
        [providerId],
    );

    const updateBookingListData = useCallback(
        (newData: IEditBookingLink[], syncToHK = true) => {
            setBookingListData([...newData]);
            setErrorMsg('');

            if (syncToHK) {
                setSavingDataToLocalstorage('bookingListData', newData);
                handleGetAppointmentsByBookingLinks(newData);
                setBookingLinkListManualEdited({});
            }
        },
        [handleGetAppointmentsByBookingLinks, setSavingDataToLocalstorage],
    );

    const handleSaveExit = useCallback(() => {
        if (Object.values(edtingModules).every((e) => !e)) {
            navigate(
                `${PATH.OPERATION}/${PATH.HELLO_KLARITY_PROVIDERS}?type=${EType.PPA}`,
            );
        } else {
            message.error('Please cancel or save your changes before leaving');
        }
    }, [edtingModules, navigate]);

    const handleChangeListStatus = useCallback(
        async (status: EProviderListMappingStatusValue, callback: () => void) => {
            if (id) {
                setStatusChangeLoading(true);
                try {
                    const res = await updateHelloKlarityListingStatus({
                        id,
                        listingStatus: status,
                    });

                    if (res && !res.error) {
                        callback?.();
                    } else {
                        message.error(res.error);
                    }
                } catch (e) {
                    console.error(e);
                }
                setStatusChangeLoading(false);
            }
        },
        [id],
    );

    const handleReject = useCallback(() => {
        handleChangeListStatus(EProviderListMappingStatusValue.DISQUALIFIED, () => {
            navigate(`${PATH.OPERATION}/${PATH.HELLO_KLARITY_PROVIDERS}`);
        });
    }, [handleChangeListStatus, navigate]);

    const handlePause = async () => {
        if (id) {
            setStatusChangeLoading(true);
            try {
                const res = await pauseHelloKlarityListing(id, pendingSubmitPrograms);

                if (res && !res.error) {
                    navigate(
                        `/${
                            PATH.HELLO_KLARITY_MAPPING_PAUSE_SUCCESS
                        }?pn=${encodeURIComponent(providerName)}&id=${id}`,
                    );
                }
            } catch (e) {
                console.error(e);
            }
            setStatusChangeLoading(false);
        }
    };

    const showMappingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingModal', true);
    }, []);

    const hideMappingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingModal', false);
    }, []);

    // mapping Confirm modal
    const hideMappingConfirmModal = useCallback(() => {
        setGlobalLayer('showProviderMappingConfirmModal', false);
    }, []);

    const showMappingConfirmModal = useCallback(() => {
        setGlobalLayer('showProviderMappingConfirmModal', true);
    }, []);

    const handleBookingDataSave = useCallback(async () => {
        if (bookingListData && bookingListData.length > 0) {
            const params = bookingListData.map((item: IEditBookingLink) => {
                const {
                    directBookingLink,
                    serviceType,
                    state,
                    specialty,
                    conditions,
                    id: bookingLinkId,
                    bookingLinkName,
                    allCondition,
                    offerId,
                } = item;
                return {
                    bookingLinkName,
                    id: bookingLinkId,
                    bpProviderId: providerId,
                    directBookingLink,
                    serviceType,
                    state,
                    specialty,
                    conditions: conditions instanceof Array ? conditions.join(',') : '',
                    allCondition: !!allCondition,
                    offerId,
                };
            });
            const res = await batchUpdateBookinglinks(params);

            if (res?.error) {
                message.error(res?.error);
            }
        }
    }, [bookingListData, providerId]);

    const handleSaveHighlight = useCallback(() => {
        return saveSpecialtyHighlight({
            providerId,
            specialtyHighlight: hightlights.join(','),
        });
    }, [hightlights, providerId]);

    const submitGolive = useCallback(async () => {
        if (id) {
            setStatusChangeLoading(true);
            try {
                const draftData = getDraftData(providerId);
                if (draftData) {
                    const saveRes = await Promise.all([
                        handleBookingDataSave(),
                        handleSaveHighlight(),
                    ]);

                    if (saveRes.find((e) => e && e.error)) {
                        saveRes.forEach((e) => {
                            if (e.error) {
                                message.error(e.error);
                            }
                        });

                        return;
                    }
                }

                const goliveRes = await helloklarityMappingGolive({
                    id,
                    programList: pendingSubmitPrograms,
                    genericInfoReq: genericDetails,
                    specificInfoReqList: specificDetails,
                });

                if (goliveRes && !goliveRes.error) {
                    removeDraftStorage(providerId);
                    hideMappingConfirmModal();
                    navigate(
                        `/${
                            PATH.HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS
                        }?pn=${encodeURIComponent(providerName)}&id=${id}`,
                    );
                } else {
                    message.error(goliveRes.error);
                }

                // if (saveRes.every((e) => e && !e.error)) {
                //     const goliveRes = await helloklarityMappingGolive(id);

                //     if (goliveRes && !goliveRes.error) {
                //         removeDraftStorage();
                //         hideMappingModal();
                //         navigate(`/${PATH.HELLO_KLARITY_MAPPING_GOLIVE_SUCCESS}?pn=${encodeURIComponent(providerName)}&id=${id}`);
                //     } else {
                //         message.error(goliveRes.error);
                //     }
                // } else {
                //     saveRes.forEach((e) => {
                //         if (e.error) {
                //             message.error(e.error);
                //         }
                //     });
                // }
            } catch (e) {
                console.error(e);
            }
            setStatusChangeLoading(false);
        }
    }, [
        id,
        providerId,
        pendingSubmitPrograms,
        genericDetails,
        specificDetails,
        handleBookingDataSave,
        handleSaveHighlight,
        hideMappingConfirmModal,
        navigate,
        providerName,
    ]);

    const handleGolive = useCallback(() => {
        if (!bookingListData || bookingListData.length === 0) {
            setErrorMsg('Please enter at least one direct booking link');
            return;
        } else {
            setErrorMsg('');
        }
        if (Object.values(edtingModules).every((e) => !e)) {
            if (
                conflict === 'true' &&
        mappingStatus !== EProviderMappingStatusValue.EHR_MAPPED
            ) {
                showMappingConfirmModal();
            } else {
                submitGolive();
            }
        } else {
            message.error('Please cancel or save your changes before leaving');
        }
    }, [
        bookingListData,
        edtingModules,
        conflict,
        mappingStatus,
        showMappingConfirmModal,
        submitGolive,
    ]);

    React.useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event?.data?.mounted) {
                setIframeLoaded({});
            }
        });
    }, []);
    // const handleIFrameLoaded = useCallback(() => {
    //     setIframeLoaded(true);
    //     // if (postMessageData.current.appointmentList && postMessageData.current.appointmentList.length > 0) {
    //     //     handleBookingLinkPostMessage(postMessageData.current.appointmentList);
    //     // }

    //     // if (postMessageData.current.hightlights) {
    //     //     handleHighlightChangePostMessage(postMessageData.current.hightlights);
    //     // }
    // }, []);

    const setIframeEl = useCallback((el: HTMLIFrameElement) => {
        iframeEl.current = el;
    }, []);

    const handlePlatformChange = useCallback((platform: string) => {
        pppTabIndexOffset.current = platform === 'mobile' ? 1 : 0;
    }, []);

    // const handleIframeReload = useCallback(() => {
    //     if (iframeEl.current) {
    //         iframeEl.current.src += '';
    //     }
    // }, []);

    const handleSaveSuccess = useCallback(
        (v: string[]) => {
            setHighlights(v);
            setSavingDataToLocalstorage(
                'specialtiesHighlights',
                v ? v.join(',') : '',
            );
            postMessageData.current.hightlights = v;
            handlePostMessage();
            // handleIframeReload();
        },
        [handlePostMessage, setSavingDataToLocalstorage],
    );

    const handleSubmit = useCallback(
        async (data: any, field: EditModuleEnum, callback?: () => void) => {
            const draftData: IDraftStorage = getDraftData(providerId);
            const { profileData } = draftData || {};
            const draftSpecificDetails = profileData?.specificInfoReqList || [];
            const result: IProfileDataSaveInput = {
                genericInfoReq: {
                    tags: genericDetails?.tags || [],
                    prescribableMedications:
            genericDetails?.prescribableMedications || [],
                    nonPrescribableMedications:
            genericDetails?.nonPrescribableMedications || [],
                },
                specificInfoReqList: draftSpecificDetails,
            };

            if (field === EditModuleEnum.GENERIC_TAGS) {
                result.genericInfoReq.tags = data;
            }

            if (field === EditModuleEnum.GENERIC_MEDICATIONS_PRESCRIBED) {
                result.genericInfoReq.prescribableMedications =
          data.prescribableMedications;
                result.genericInfoReq.nonPrescribableMedications =
          data.nonPrescribableMedications;
            }

            if (field === EditModuleEnum.SPECIFIC_UNIPROFILE) {
                // 找出data中conditionId与draftData中conditionId相同的项，
                // 如果有的话，覆盖掉，否则新增
                const index = draftSpecificDetails.findIndex(
                    (e) => e.condition === data.condition,
                );

                if (index !== -1) {
                    draftSpecificDetails[index] = {
                        ...draftSpecificDetails[index],
                        ...data,
                    };
                } else {
                    draftSpecificDetails.push(data);
                }
                result.specificInfoReqList = draftSpecificDetails;
            }

            postMessageData.current.genericDraftData = result.genericInfoReq;
            postMessageData.current.specificDraftData =
        result.specificInfoReqList.find((e) => e.condition === conditionId);

            setSavingDataToLocalstorage('profileData', result);
            handleGetData();

            callback?.();
        },
        [
            genericDetails,
            providerId,
            setSavingDataToLocalstorage,
            handleGetData,
            conditionId,
        ],
    );

    const handleMainTabChange = useCallback(
        (key: string) => {
            setTabKey(key);
            handleGetData();
        },
        [handleGetData],
    );

    const providerHasEffectiveMic = hasEffectiveMic(providerData);

    return (
        <Spin
            spinning={
                !!(
                    !iframeLoaded ||
            fetchLoading ||
            bookingListLoading ||
            statusChangeLoading ||
            specificConditionDetailLoading
                )
            }
        >
            <div className={s.wrap}>
                <MappingModalConfirm
                    type={EType.HELLOW_KLARITY}
                    onOk={submitGolive}
                    onCancel={hideMappingConfirmModal}
                />
                {/* <PorivderMappingModal
                    row={mappingModalData}
                    onOk={submitGolive}
                    onCancel={hideMappingModal}
                /> */}
                <div className={s.left}>
                    <div className={s.providerName}>{providerName}</div>
                    <BookingLink
                        title="Bookable services"
                        specialtyNServiceTypeData={specialtyNServiceTypeData}
                        providerId={providerId}
                        data={bookingListData}
                        updateBookingListData={updateBookingListData}
                        errorMsg={errorMsg}
                        providerType={EType.PPA}
                        // refetch={bookingListrefetch}
                    />
                    <div className={s.tabs}>
                        <div
                            className={`${s.tabItem} ${
                                tabKey === 'genericProfile' ? s.tabItemActive : ''
                            }`}
                            onClick={() => {
                                handleMainTabChange('genericProfile');
                            }}
                        >
                            Generic profile
                        </div>
                        <div
                            className={`${s.tabItem} ${
                                tabKey === 'specificProfile' ? s.tabItemActive : ''
                            }`}
                            onClick={() => {
                                handleMainTabChange('specificProfile');
                            }}
                        >
                            Condition-specific profile
                        </div>
                    </div>
                    {tabKey === 'genericProfile' && (
                        <UpdateUniprofile
                            genericDetails={genericDetails}
                            onTabChange={handleTabChange}
                            id={id}
                            setSpecialtiesIsEdting={setSpecialtiesIsEdting}
                            specialtiesIsEdting={specialtiesIsEdting}
                            providerData={providerData}
                            refetch={refetch}
                            onSaveSuccess={handleSaveSuccess}
                            onSubmit={handleSubmit}
                        />
                    )}
                    {tabKey === 'specificProfile' && (
                        <UpdateSpecificUniprofile
                            bookingLinkListManualEdited={bookingLinkListManualEdited}
                            setConditionId={setConditionId}
                            conditionId={conditionId}
                            onTabChange={handleTabChange}
                            id={id}
                            providerId={providerId}
                            providerData={providerData}
                            refetch={refetch}
                            onSaveSuccess={handleSaveSuccess}
                            onSubmit={handleSubmit}
                            specificConditionDetail={
                                conditionId
                                    ? specificDetails.find((e) => e.condition === conditionId)
                                    : specificDetails[0]
                            }
                            fetchSpecificConditionDetail={fetchSpecificConditionDetail}
                        />
                    )}
                </div>
                <div className={s.right}>
                    <Previwe
                        // onLoad={handleIFrameLoaded}
                        providerId={providerId}
                        handlePlatformChange={handlePlatformChange}
                        setIframeEl={setIframeEl}
                        slug={slug}
                        postMessageData={postMessageData.current}
                        condition={conditionId}
                        type={tabKey}
                    />
                </div>
                <div className={s.footer}>
                    <div className={s.exit} onClick={handleSaveExit}>
                        Save & exit
                    </div>
                    <div className={s.rightBtns}>
                        {listStatus !== EProviderListMappingStatusValue.LISTED && (
                            <div className={s.reject} onClick={handleReject}>
                                Disqualify
                            </div>
                        )}
                        {(listStatus === EProviderListMappingStatusValue.LISTED ||
                listStatus ===
                  EProviderListMappingStatusValue.PENDING_REVIEW) && (
                  <div onClick={handlePause} className={s.pause}>
                                Pause Listing (Preferred)
                </div>
                        )}
                        {listStatus === EProviderListMappingStatusValue.LISTED ? (
                            <Button type="primary" onClick={handleGolive}>
                                Publish changes
                            </Button>
                        ) : (
                            <Button type="primary" onClick={handleGolive}>
                                Go live
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </Spin>
    );
};

export default CustomizeHelloKlarityPPP;
